import { Icon, Popover, PopoverHeading, PopoverItem, PopoverRule, useToast } from "@helmr/ui";
import { useNavigate } from "react-router-dom";
import { isApiError } from "../api/client";
import { logout, logoutAll } from "../api/auth";
import { useAppContext } from "./permissions";
import { useServices } from "./services";
import { strings } from "./strings";
import s from "./shell.module.css";
import { useState } from "react";
import { initials } from "@helmr/ui";

const t = strings.shell;

export function AccountMenu() {
  const ctx = useAppContext();
  const { client, session, queryClient } = useServices();
  const navigate = useNavigate();
  const toast = useToast();
  // The API refuses logout-all on a front-desk session and does not say which kind this is: once refused, hide it.
  const [restricted, setRestricted] = useState(false);

  const name = ctx.me?.staff.name ?? "";
  const role = ctx.me ? `${ctx.me.staff.roleName} · ${ctx.me.business.name}` : "";

  async function out(everywhere: boolean) {
    try {
      await (everywhere ? logoutAll(client) : logout(client));
    } catch (err) {
      if (everywhere && isApiError(err) && err.isForbidden) { setRestricted(true); toast.show(t.signOutEverywhereRefused); return; }
      // "Everywhere" protects other devices: do not pretend it happened. A 401 means this session is already gone.
      if (everywhere && !(isApiError(err) && err.status === 401)) { toast.show(t.signOutEverywhereFailed); return; }
      // Plain sign-out: the device may be offline or the session already dead; signing out locally is still right.
    }
    session.signOut(null);
    queryClient.clear();
    navigate("/signin", { replace: true });
  }

  return (
    <Popover
      role="menu"
      label={t.account}
      trigger={(p) => (
        <button {...p} className={s.me} aria-label={name ? `${t.account}: ${name}` : t.account}>
          <span className={s.av}>{name ? initials(name) : <Icon name="user" size={14} />}</span>
          <span className={s.nm}>{name}</span>
        </button>
      )}
    >
      {({ close }) => (
        <>
          {name ? <div className={s.who}><b>{name}</b><small>{role}</small></div> : <PopoverHeading>{t.account}</PopoverHeading>}
          <PopoverRule />
          <PopoverItem lead={<Icon name="user" />} disabled hint={t.profileSoon}>{t.profile}</PopoverItem>
          <PopoverItem lead={<Icon name="logout" />} onClick={() => { close(); void out(false); }}>{t.signOut}</PopoverItem>
          {restricted ? null : <PopoverItem lead={<Icon name="logout" />} onClick={() => { close(); void out(true); }}>{t.signOutEverywhere}</PopoverItem>}
        </>
      )}
    </Popover>
  );
}
